import { render, staticRenderFns } from "./Video-list.vue?vue&type=template&id=e73d3f46&scoped=true&"
import script from "./Video-list.vue?vue&type=script&lang=js&"
export * from "./Video-list.vue?vue&type=script&lang=js&"
import style0 from "./Video-list.vue?vue&type=style&index=0&id=e73d3f46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e73d3f46",
  null
  
)

export default component.exports